export default "__VITE_ASSET__CeITsK13__"